<div class="tabs flex flex-nowrap">
  <div *ngFor="let tab of tabs; let i = index" (click)="toggleTab(i)" [ngClass]="tab.tabActive ? 'tab-active font-bold ' : ''"
    class="tab tab-lifted text-primary">
    {{tab.name}}
  </div>
</div>